/**
 * Dashboard / Status page
 *
 */

'use strict'

var App = require('app')
var Marionette = require('marionette')

/* Views */
var List = require('./show')

var PageStatus = function () {
  /* Routes ----------------------------------------------------------------- */
  var Router = App.PermissionAppRouter.extend({
    appRoutes: {
      '': 'show',
      'status': 'show'
    }
  })

  /* API -------------------------------------------------------------------- */
  var API = {
    show: function () {
      new List()
    }
  }

  /* Listeners -------------------------------------------------------------- */
  App.globalChannel.on('page-status:show', function (options) {
    API.show()
  })

  new Router({ controller: API })
}

module.exports = PageStatus



// WEBPACK FOOTER //
// ./js/modules/page-status/index.js